import { EditOutlined } from "@ant-design/icons";
import { ConfigProvider, Modal, Table, Typography } from "antd";
import { useDispatch } from "react-redux";
import { UserDealerDetails } from "../../../redux/actions/userActions/dealerActions";
import { useEffect, useState } from "react";
import { logout } from "../../../redux/reducers/authSlice";
import Alertify from "../../../services/alertify";

const { Title } = Typography;
const ShippingAddresses = (props) => {
  const dispatch = useDispatch();
  const [shippingAddresses, setShippingAddresses] = useState();
  const [changeAddressModal, setChangeAddressModal] = useState(false);
  const {
    dealer_code,
    setBalanceCredit,
    setDefaultShippingAddress,
    defaultShippingAddress,
  } = props;
  useEffect(() => {
    dispatch(UserDealerDetails({ dealerCode: dealer_code }))
      .then((response) => {
        // console.log("Dealer Details are:", response);
        if (
          response?.error?.message &&
          (response?.error?.message.toLowerCase().includes("expired") ||
            response?.error?.message.toLowerCase().includes("invalid"))
        ) {
          Alertify.error("Your session is expired. Please login again.");
          dispatch(logout());
          props.setLocation("/login/dealer");
          return;
        }
        const res = response?.payload?.data;
        setBalanceCredit(res?.balance_credit);
        setShippingAddresses(res?.shipping_addresses);
        setDefaultShippingAddress(res?.shipping_addresses[0]);
      })
      .catch((error) => {
        Alertify.error("Error fetching dealer details:", error);
        dispatch(logout());
        props.setLocation("/login/dealer");
        return;
      });
  }, [
    dispatch,
    dealer_code,
    setBalanceCredit,
    setDefaultShippingAddress,
    setShippingAddresses,
  ]);
  const handleAddressChange = (value) => {
    setDefaultShippingAddress(value);
    setChangeAddressModal(false);
  };
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      handleAddressChange(selectedRows[0]);
    },
  };
  // console.log(defaultShippingAddress, "shippingAddresses");
  const addressesCol = [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Address", dataIndex: "street", key: "street" },
    { title: "City", dataIndex: "city", key: "city" },
    { title: "State", dataIndex: "state", key: "state" },
    { title: "Pincode", dataIndex: "pincode", key: "pincode" },
  ];
  return (
    <ConfigProvider
      theme={{
        components: {
          Typography: {
            titleMarginTop: 0,
            titleMarginBottom: 0,
          },
          Modal: {
            borderRadiusLG: 8,
          },
        },
      }}
    >
      <div className="bg-gray-50 rounded-lg p-4 shadow-lg max-sm:mt-8">
        <div className="flex items-center justify-between">
          <Title level={4}>Shipment Details</Title>
          <EditOutlined
            onClick={() => setChangeAddressModal(true)}
            className="text-[#B91C1C]"
          />
        </div>
        <div className="flex mt-4">
          <strong>City</strong>
          <p className="ml-auto">
            {defaultShippingAddress?.city}, {defaultShippingAddress?.pincode}
          </p>
        </div>
        <div className="flex mt-4">
          <strong>Address</strong>
          <p className="ml-auto text-right ps-2 text-wrap break-words">
            {defaultShippingAddress?.street}
            {defaultShippingAddress?.address_2}
          </p>
        </div>
      </div>
      <Modal
        open={changeAddressModal}
        onCancel={() => setChangeAddressModal(false)}
        footer={false}
        width={1000}
        centered
      >
        <div>
          <div className="flex items-center gap-16">
            <Title level={3}>Address List</Title>
          </div>
          <Table
            rowKey="code"
            className="max-w-full"
            size="small"
            pagination={false}
            rowSelection={{ type: "radio", ...rowSelection }}
            columns={addressesCol}
            dataSource={shippingAddresses}
          />
        </div>
      </Modal>
    </ConfigProvider>
  );
};
// https://www.youtube.com/watch?v=ug54-M5qxAk
export default ShippingAddresses;
